import {FC} from 'react';

import DefaultLogo from './svg/logo-default.svg';

interface FooterLogoProps {
  className?: string;
}

export const FooterLogo: FC<FooterLogoProps> = ({className}) => (
  <DefaultLogo className={className} width="50" height="18.5" />
);
